import React, { useContext } from 'react';
import * as style from './caption.module.scss';
import ArticleThemeContext from '../../context/articleThemeContext';

const Caption = props => {
  const theme = useContext(ArticleThemeContext);

  return (
    <div
      className={`${theme === 'dark' ? 'text-block' : ''} ${style.captionWrap} ${props.captionFullOpacity ? style.fullOpacity : ''}`}
    >
      {props.captionHead && <h3>{props.captionHead}</h3>}
      {props.captionHead && <span />}{/* MISSING_CLASS_NAME:  className={style.captionDivider} */}
      {props.captionText && props.captionText.includes('<p>') ? (
        <div>
          <span className={style.captionText} dangerouslySetInnerHTML={{ __html: props.captionText }} />
          <span className={style.creditText} dangerouslySetInnerHTML={{ __html: props.creditText }} />
        </div>
      ) : (
        <p>{props.captionText} {props.creditText}</p>
      )}
    </div>
  );
};

export default Caption;
